// Make the Bootstrap tab control target the tab panel in addition to the tab button when showing / hiding tabs.

function setupTabbedContent() {
	$('body').off('show.bs.tab hide.bs.tab', '[data-toggle=tab][data-target').on('show.bs.tab hide.bs.tab', '[data-toggle=tab][data-target]', function(event) {
		var e = $.Event(event);
		var r = $($(this).data('target')).trigger(event.type + '.bs.tab', e);
		if (e.isDefaultPrevented()) event.preventDefault();
	}).off('shown.bs.tab hidden.bs.tab', '[data-toggle=tab][data-target]').on('shown.bs.tab hidden.bs.tab', '[data-toggle=tab][data-target]', function(event) {
		$($(this).data('target')).trigger(event.type + '.bs.tab', $.Event(event));
	});
	
	require('tabbed-content').setup();
}

$(setupTabbedContent);
